import React from 'react'

import type { SelectOption } from '@fourthwall/components'
import { Select } from '@fourthwall/components'
import type { useFormik } from '@fourthwall/utils/dist/formik'

import type { FormValues, Rules } from '../../hooks/useBadgeForm/types'
import { FormFields } from '../../hooks/useBadgeForm/types'

type Props = {
  form: ReturnType<typeof useFormik<FormValues>>
  options: SelectOption[]
  onChange?: () => void
}

export const SelectRule = ({ form, options, onChange }: Props) => (
  <Select
    options={options}
    label="Requirement to earn badge"
    fullWidth
    value=""
    onValueChange={(value) => {
      let newRule

      if (value === 'MemberStreak') {
        newRule = { type: 'MemberStreak', monthsFrom: 0, monthsTo: 0 } satisfies Rules[number]
      } else if (value === 'Tier') {
        newRule = { type: 'Tier', tierId: undefined } satisfies Rules[number]
      } else {
        newRule = { type: value as Rules[number]['type'] } satisfies Rules[number]
      }

      form.setFieldValue(FormFields.rules, [
        ...form.values.rules.filter((rule) => rule.type !== 'EmptyRule'),
        newRule,
      ])
      onChange?.()
    }}
  />
)
